<template>
	<header class="portal-page-header">
		<div class="portal-page-header__text">
			<Text font="var(--portal-heading, var(--heading-h2))" color="--text-dark-primary" role="heading" aria-level="1">
				{{ title }}
			</Text>
			<Text v-if="subtitle" font="--text-16-22-reg" color="--text-dark-secondary">{{ subtitle }}</Text>
		</div>
		<div v-if="$slots.action" class="portal-page-header__action">
			<slot name="action" />
		</div>
	</header>
</template>

<script setup lang="ts">
import { Text } from '@simple-life-app/growth-ui-kova'

/**
 * How a section page opens (Figma 13833:135635 "Header Desktop", 14254:169712 on a phone): the title, an
 * optional subtitle and, in the `action` slot, the page's one action — one row at every width; the action
 * is the full button on desktop ("Need help with your order?") and the 40px icon-only button on a phone.
 * The sections reuse it so every page starts the same way. The title's font is the
 * shell's `--portal-heading` (24/28 on a phone, 32/38 from 1024 — the DS heading sizes), with the plain
 * `--heading-h2` as the fallback outside the shell.
 */

defineProps<{
	title: string
	subtitle?: string
}>()
</script>

<style scoped>
.portal-page-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--size-16);
}

.portal-page-header__text {
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	min-width: 0;
}

.portal-page-header__action {
	flex: none;
}

@container portal (min-width: 1024px) {
	.portal-page-header {
		gap: var(--size-24);
	}
}
</style>
